import { useDeviceFormat } from "@/hooks/useDeviceFormat";
import { Progress } from "../ui/progress";
import { Step, StepItem, Stepper, useStepper } from "../ui/stepper";

export type StepItemsList = Array<StepItem & { element: React.ReactNode }>;

export const LayoutSetup = ({ steps }: { steps: StepItemsList }) => {
  const { isMobile } = useDeviceFormat();

  return (
    <div
      className={`absolute left-0 flex-1 w-full overflow-auto flex justify-center ${
        isMobile ? "h-full" : "h-[calc(100%-var(--app-header-height))] top-(--app-header-height)"
      }`}
    >
      <div className="flex flex-col w-full max-w-[800px] gap-6">
        <Stepper
          initialStep={0}
          steps={steps}
          variant="circle-alt"
          styles={{
            "vertical-step-container": "hidden",
            ...(isMobile ? {} : { "main-container": "hidden" }),
          }}
        >
          <ProgressBar />
          {steps.map((stepProps) => {
            return (
              <Step key={stepProps.label} {...stepProps}>
                <div
                  className={`flex items-center justify-center pb-24 my-2 text-primary ${
                    isMobile ? "p-4" : "p-10"
                  }`}
                >
                  {stepProps.element}
                </div>
              </Step>
            );
          })}
        </Stepper>
      </div>
    </div>
  );
};

const ProgressBar = () => {
  const { activeStep, steps } = useStepper();
  const { isMobile } = useDeviceFormat();

  return (
    <Progress
      value={(activeStep / (steps.length - 1)) * 100}
      className={`${isMobile ? "top-0px" : "top-(--app-header-height)"} fixed left-0 w-full rounded-none`}
    />
  );
};
